import { useQuery, UseQueryResult } from 'react-query';
import { getAccessibleProfiles } from 'services/profiles';

export const useProfiles = (): UseQueryResult<ProfilesResponse> => {
  return useQuery(['profiles'], () => getAccessibleProfiles());
};
